module.exports = __webpack_public_path__ + "img/crystal-palace.fe7903bd.png";